export default "__VITE_ASSET__CqG48HKP__"